
import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Actions, Effect } from '@ngrx/effects';
import { DefaultTasksColumnsFilterActionTypes } from '../actions/task-filters/default-columns-filter.actions';
import { TasksSavedListResetAction } from '../actions/task-filters/tasks-saved-list.actions';

@Injectable()
export class DefaultTasksColumnsFilterEffects {
  @Effect()
  DefaultColumnsFilterToggleItemAction = this._actions$
    .ofType(DefaultTasksColumnsFilterActionTypes.TOGGLE_ITEM_ID).pipe(
    map(_ => new TasksSavedListResetAction()));

  constructor(private _actions$: Actions) {}
}
